module.exports = __webpack_public_path__ + "img/rob-ludwin.118536e8.jpg";